import moment from 'moment'
import { Template, Component, Attribute } from '@scoutgg/ftw/source/lib'
import notify from '@scoutgg/ftw/source/services/notification'
import template from './matches-confirmation.jade'
import { Season, Match } from '../../models'
import '../seasons'
import {prompt} from '@scoutgg/ftw/source/services/modal'
import sources from '../../../helpers/sources'
import emitter from '@scoutgg/ftw/source/services/emitter'

@Component('sporty')
@Template(template)
@Attribute('season', Season)
@Attribute('after', moment)
@Attribute('before', moment)
class SportsbookConfirmation extends HTMLElement {
  created() {
    this.storedSeasons = localStorage.getItem('conf-season-filter')
    this.seasonFilter = this.storedSeasons ? JSON.parse(this.storedSeasons) : []
    this.filterType = ['All statuses']
  }

  attached() {
    if(typeof(this.sportsbookOnly) == "undefined") {
      this.sportsbookOnly = false
    }
    this.shown = false
    this.after = moment().startOf('day').toISOString()
    if(!this.roundNum) this.roundNum = 'All rounds'
    if(!rounds) var rounds = ['All rounds']
    Season.load({ active: true }).then(({ seasons }) => {
      if(!this.seasonLoad) this.seasonLoad = 1
      const sport = this.season?.sport
      const sports = ["All sports"]
      sports.push(...Array.from(new Set(seasons.map(season => season.sport))))
      this.applyState({ seasons, sport, sports, rounds })
      this.reload()
    })
  }

  changeFilterType(type) {
    if(type === 'All statuses') {
      this.filterType = ['All statuses']
    } else {
      this.filterType = this.filterType.filter(s => s !== 'All statuses')
      const index = this.filterType.indexOf(type)
      if(index === -1) {
        if(type === 'Live') {
          this.filterType.push('Paused')
        }
        this.filterType.push(type)
      } else {
        if(type === 'Live') {
          this.filterType.splice(index-1, 2)
        }
        else {
          this.filterType.splice(index, 1)
        }
      }
    }
    this.reload()
  }

  changeRoundNum(roundNum) {
    this.roundNum = roundNum
    this.reload()
  }

  afterChange () {
    if(!this.seasonLoad) this.seasonLoad = 1
    this.reload()
  }

  prompt(status, endpoint, question, id) {
    return prompt(question, { type: 'yesno' }).then(() => {
      this.updateStatus(status, endpoint, id)
    })
  }

  updateSheet() {
    this.render()
  }

  updateStatus(status, endpoint, id) {
    this.arrayMatches.forEach((element) => {
      if(element._id === id) {
        const prevStatus = element.status
        element.status = status
        this.render()
        return element.post(endpoint, {})
          .then(() => {
            notify('Match confirmation sent', { level: 'success', timeout: 5000 })
            this.emit('changed-status:match')
          })
          .catch(err => {
            notify(err.message || err.error, {level: 'danger', timeout: 10000})
            this.match.status = prevStatus
            this.render()
          })
          .then(() => {
            this.sendEvents(id)
          })
      }
    })
  }

  sendEvents(id) {
    this.arrayMatches.forEach((element) => {
      if(element._id === id) {
        element.post('send-feeds')
        .then(() => {
          notify('Events sent', {level: 'success', timeout: 5000}) })
        .catch((err) => {
          notify(err.message, {level: 'danger', timeout: 10000})
        })
      }
    })
  }

  styleStatus(matchStatus) {
    let color = ''
    if(matchStatus) {
      switch (matchStatus) {
        case 'pending':
          color = 'black'
          break
        case 'live':
          color = 'green'
          break
        case 'paused':
          color = 'orange'
          break
        default:
          color = 'brown'
      }
    }
    return color
  }

  toggleFeeds(match) {
    if(match.$isSubmitting) {
      return
    }
    if(match.stopFeeds) {
      prompt('As an admin type "UNLOCK" to unlock this match', { min: 1, max: 10 })
        .then(str => {
          match.post('start-feeds', { code: str })
            .then(() => {
              notify('Feeds started', { level: 'success', timeout: 5000 })
              this.render(match.stopFeeds = false)
            }).catch((err) => {
              notify(err.message, {level: 'danger', timeout: 10000})
            })
        })
    } else {
      match.stopFeeds = true
      match.post('stop-feeds').then(() => {
        notify('Feeds stopped', { level: 'success', timeout: 5000 })
      }).catch((err) => {
        notify(err.message, {level: 'danger', timeout: 10000})
      })
    }
    this.render()
  }

  async toggleAutoconfirm(match) {
    const answer = prompt('Are you sure you want to toggle autoconfirm? Type yes')
    if(answer !== 'yes') {
      return
    }
    await match.post('toggle-autoconfirm', { autoconfirm: match.autoconfirm })
    notify(`Autoconfirm turned ${!match.autoconfirm ? 'on' : 'off'}`, {
      level: 'success',
      timeout: 3000,
    })
    match.autoconfirm = !match.autoconfirm
    emitter.emit('match-updated')
    this.render()
  }

  scrapeFeeds(match) {
    match.load().then((matchDetails) => {
      const status = matchDetails.match.status
      const score = matchDetails.match.subScore
      const source = (matchDetails.matchSources || [])
        .filter(ms => ms.source && ms.source !== 'custom')
        .find(ms => ms.uid && sources[ms.source])
      if(source) {
        source.post('scrape').then(() => {
          notify('Lineups gathered', {level: 'success', timeout: 5000})
          match.load({ $reload: true }).then((newMatchDetails) => {
            let renderFlag = null
            this.arrayMatches.forEach((element) => {
              if(element._id === newMatchDetails.match._id) {
                if(newMatchDetails.match.status !== status) {
                  element.status = newMatchDetails.match.status
                  renderFlag = 1
                }
                if(newMatchDetails.match.subScore !== score) {
                  element.subScore = newMatchDetails.match.subScore
                  if(newMatchDetails.match.score) {
                    element.score = newMatchDetails.match.score
                  }
                  renderFlag = 1
                }
              }
            })
            if(renderFlag) {
              this.updateSheet()
            }
          })
        }).catch((err) => {
          console.error(err.stack)
          notify(err.message, {level: 'danger', timeout: 10000})
        })
      }
      else {
        notify('This match cannot be scraped', { level: 'danger', timeout: 5000 })
      }
    })
  }

  seasonCheck(season) {
    let result = null
    if (!this.sportsbookOnly) {
      result = 1
    }
    if (season.sportsbookOnly == true) {
      result = 1
    }
    if (this.seasonClass(season) == 'selected') {
      result = 1
    }
    return result
  }

  changeSeason({ season }) {
    this.season = season
    this.reload()
  }

  changeSport(sport) {
    this.season = undefined
    this.sport = (sport !== 'All sports') ? sport : undefined
    if(!this.seasonLoad) this.seasonLoad = 1
    this.applyState({
      sport: this.sport,
      season: this.season
    })
    this.reload()
  }

  formatScore(score) {
    if (score) {
      return `${score[0]} - ${score[1]}`
    }
    else {
      return ''
    }
  }

  seasonClass(season) {
    if(this.seasonFilter.includes(season._id)) return 'selected'
  }

  seasonsSelect() {
    this.shown = !this.shown
    this.render()
  }

  goBack() {
    this.seasonsSelect()
    this.reload()
  }

  deselect() {
    this.seasonFilter = []
    localStorage.removeItem('conf-season-filter')
    this.render()
  }

  toggle(season) {
    var index = this.seasonFilter.indexOf(season)
    if(index < 0) {
      this.seasonFilter.push(season)
    } else {
      this.seasonFilter.splice(index, 1)
    }
    localStorage.setItem('conf-season-filter', JSON.stringify(this.seasonFilter))
    this.reload()
  }

  toggleSportsbookOnly() {
    this.sportsbookOnly = !this.sportsbookOnly
    this.render()
  }

  reload() {
    var params = {
      $reload: true
    }
    if(!this.season) {
      params.seasons = this.seasonFilter
    }
    else {
      params.season = this.season._id
    }
    if(this.after) {
      this.before = moment(this.after).endOf('day').toISOString()
      params.after = this.after
      params.before = this.before
    }
    if((this.filterType) && (!this.filterType.includes('All statuses'))) {
      params.status = this.filterType.map(status => {
        return status.toLowerCase()
      })
    }
    if((this.roundNum) && (this.roundNum !== 'All rounds')) {
      params.round = this.roundNum.toString()
    }
    if(this.sport) {
      params.sport = this.sport
    }
    Match.load(params).then(({ matches, seasonCount, seasons }) => {
      this.seasonCount = {}
      this.seasons = seasons
      const seasonIds = seasons.reduce((set, s) => set.add(s._id), new Set())
      this.seasonFilter = this.seasonFilter.filter(s => seasonIds.has(s))
      seasonCount.forEach(({_id, count}) => {
        this.seasonCount[_id] = count
      })
      if(this.seasonLoad) {
        let tempArr = ['All rounds']
        matches.forEach((elem) => {
          tempArr.push(elem.round)
        })
        let resultObj = new Set(tempArr)
        var rounds = [...resultObj].sort((b,a) => b - a)
        if(this.seasonLoad) {
          this.seasonLoad = null
        }
        this.applyState({rounds})
      }
      this.applyState({
        arrayMatches: matches
          .filter(m => m.round > 0)
          .filter(m => +m.startTime)
          .sort((b, a) => {
            return (+a.startTime - +b.startTime) || (a.round - b.round)
          }),
      })
    }).then(()=> {
      this.sortedSeasons = this.seasonSport
    })
  }

  sortedSportSeasons(sport) {
    return sport.sortedSeasons.sort((a, b) => a.name.localeCompare(b.name))
  }

  get seasonSport() {
    var newArr = [],
        sports = {}
    for(const cur of this.seasons) {
      if (!(cur.sport in sports)) {
        sports[cur.sport] = {type: cur.sport, sortedSeasons: []}
        newArr.push(sports[cur.sport])
      }
      sports[cur.sport].sortedSeasons.push(cur)
    }
    return newArr
  }
}

export default SportsbookConfirmation
